import React from 'react';
import { BrowserRouter, Routes, Route,   Navigate } from 'react-router-dom';
import Header from '../components/Header';
import AddCase from '../components/AddCase';
import Login from '../components/Login';
import AddDocument from '../components/AddDocument';
import AddFile from '../components/AddFile';
import CasesList from '../components/CasesList';
import CaseView from '../components/CaseView';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles';
const theme = createTheme( {
  palette: {
    mode: 'light',
    primary: {
      main: '#255079',
    },
    secondary: {
      main: '#696969',
    },
    background: {
      paper: '#ffffff',
      default: '#fcfcfc',
    },
  },
});
const isAuthenticated = () => {
  // Check if a token exists in local storage
  return localStorage.getItem('token') !== null;
};
const ProtectedRoute = ({ element, ...rest }) => {
  return isAuthenticated() ? (
    element
  ) : (
    <Navigate to="/login" replace />
  );
};
const AppRouter = () => {
  return (
    <BrowserRouter>
      <div>
        <ThemeProvider theme={theme}>
        <Header />
        <div style={{marginTop: 65 }} className="main-content">
          <Routes>
            <Route element={<Login />} path="/login"  />
             
            <Route element={<ProtectedRoute element={<CasesList />} />} path="/"  />
            <Route element={<ProtectedRoute element={<CasesList />} />} path="/cases"  />
            <Route element={<ProtectedRoute element={<CaseView />} />} path="/cases/:caseId"  />
            <Route element={<ProtectedRoute element={<AddCase />} />} path="/add_case" />
            <Route element={<ProtectedRoute element={<AddDocument isContextDoc={false} />} />} path="/cases/:caseId/add_document" />
            <Route element={<ProtectedRoute element={<AddDocument isContextDoc={true} />} />} path="/cases/:caseId/add_factset" />
          </Routes>
        </div>
        </ThemeProvider>
      </div>
    </BrowserRouter>
  );
};

export default AppRouter;
